import { Outlet, useNavigate } from "react-router-dom";
import "./onboard-layout.scss";
import { IMenuNavItem } from "../../common/inerfaces/component-interfaces";
import { Container } from "react-bootstrap";
import headerImg from "../../assets/media/icons/Trowel-Logo.png";
import Avatar from "../../components/avatar";
import defaultAvatarImage from "../../assets/media/icons/avatar.png";
import {
  IUserSessionInfo,
  userSessionStateSelector,
} from "../../redux/reducers/user-session/userSessionSlice";
import { useAppSelector } from "../../hooks/typed-hooks";
import { useEffect, useState } from "react";

const OnboardLayout: React.FC = () => {
  const navigate = useNavigate();

  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const [userInfo, setUserInfo] = useState<IUserSessionInfo | null>(null);

  useEffect(() => {
    console.log("User session infor inside header ", selectUserSessionInfo);
    setUserInfo(selectUserSessionInfo);
  }, [selectUserSessionInfo]);

  const menuItemSelectionChangeHandler = (menuItem: IMenuNavItem) => {
    navigate(menuItem.path);
  };

  return (
    <Container>
      <section className="onboard-layout-main">
        {/* <div className="linear-gradient-circle"></div>
        <div className="linear-gradient-circle botton-gradient"></div> */}

        <div className="registration-verification-overlay">
          <nav className="navbar navbar-expand-md position-absolute nav-bar-main tr-header">
            <div className="container-fluid no-pd-mg">
              {/* <div className="trowel-logo">
                <span className="trwl-logo__icon"></span>
                <span className="trwl-logo__text">TROWEL.AI</span>
              </div> */}
              <img
                className="logo-img"
                src={headerImg}
                alt="Header"
                onClick={() => navigate("/")}
              />
              <button
                data-bs-toggle="collapse"
                className="navbar-toggler"
                data-bs-target="#navcol-1"
              >
                <span className="visually-hidden">Toggle navigation</span>
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navcol-1"
                style={{ height: 56 }}
              >
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item"></li>
                </ul>
                <div className="nav-right">
                  {/* Optional: Add user dropdown here */}
                </div>
              </div>
              <span className="user-avatar-span">
                <Avatar
                  src={userInfo?.profileImage || defaultAvatarImage}
                  width="2.5rem"
                  height="2.5rem"
                />
              </span>
            </div>
          </nav>

          <div className="onboard-layout-body">
            <Outlet />
          </div>
        </div>
      </section>
    </Container>
  );
};

export default OnboardLayout;
